import { render, staticRenderFns } from "./PreviewFooter.vue?vue&type=template&id=7ca0070e&scoped=true"
import script from "./PreviewFooter.vue?vue&type=script&lang=ts"
export * from "./PreviewFooter.vue?vue&type=script&lang=ts"
import style0 from "./PreviewFooter.vue?vue&type=style&index=0&id=7ca0070e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca0070e",
  null
  
)

export default component.exports